import { useServiceSubjectsHost } from '@euler/app/flows/order/pages/ServiceSubjectsScreen/host';
import { useBehaviorSubject } from '@euler/utils/hooks';
import { createMaterialTopTabNavigator } from '@react-navigation/material-top-tabs';
import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { AnimatePresence } from 'moti';
import { memo, useEffect } from 'react';
import { View } from 'react-native';
import { ServiceSubjectCategoryTab } from './ServiceSubjectCategoryTab';
import { ServiceSubjectTabContent } from './ServiceSubjectTabContent';
import { useServiceSubjectsContext } from './ServiceSubjectsContext';
import { ServiceSubjectsSearchContent } from './ServiceSubjectsSearchContent';

const Tab = createMaterialTopTabNavigator();

export const ServiceSubjectsContent = memo(() => {
  const { categories } = useServiceSubjectsContext();
  const { serviceSubjectQuery$ } = useServiceSubjectsHost();
  const [keyword] = useBehaviorSubject(serviceSubjectQuery$);
  const navigation = useNavigation<StackNavigationProp<any>>();

  useEffect(() => {
    return navigation.addListener('beforeRemove', e => {
      if (keyword) {
        e.preventDefault();
        // Clear the search query when navigating away
        serviceSubjectQuery$.next('');
        return;
      }
    });
  }, [keyword, navigation, serviceSubjectQuery$]);

  return (
    <View
      css={`
        flex: 1;
      `}
    >
      <Tab.Navigator
        tabBar={props => (
          <ServiceSubjectCategoryTab categories={categories} {...props} />
        )}
        screenOptions={{
          lazy: true,
        }}
        style={{ flex: 1 }}
      >
        {categories.map(category => (
          <Tab.Screen
            key={category.name}
            name={category.name}
            component={ServiceSubjectTabContent as any}
            initialParams={{ category }}
          />
        ))}
      </Tab.Navigator>
      <AnimatePresence>
        {keyword ? <ServiceSubjectsSearchContent keyword={keyword} /> : null}
      </AnimatePresence>
    </View>
  );
});
